var aviator = new Aviator({requireFonts: false});
